function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "511pt",
    viewBox: "0 1 511 511.99998",
    width: "511pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 467.105469 15.457031 L 467.105469 135.914062 C 467.105469 144.457031 460.179688 151.375 451.648438 151.375 L 265.152344 151.375 C 256.605469 151.375 249.691406 144.457031 249.691406 135.914062 L 249.691406 15.457031 C 249.691406 6.925781 256.605469 0 265.152344 0 L 451.648438 0 C 460.179688 0 467.105469 6.925781 467.105469 15.457031 Z M 467.105469 15.457031 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,88.235294%,73.333333%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 467.105469 15.457031 L 467.105469 135.914062 C 467.105469 144.457031 460.179688 151.375 451.648438 151.375 L 358.398438 151.375 L 358.398438 0 L 451.648438 0 C 460.179688 0 467.105469 6.925781 467.105469 15.457031 Z M 467.105469 15.457031 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,82.745098%,60%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 358.398438 73.957031 L 358.398438 135.914062 C 358.398438 144.457031 351.472656 151.375 342.941406 151.375 L 208.992188 151.375 C 200.449219 151.375 193.535156 144.457031 193.535156 135.914062 L 193.535156 73.957031 C 193.535156 65.421875 200.449219 58.496094 208.992188 58.496094 L 342.941406 58.496094 C 351.472656 58.496094 358.398438 65.421875 358.398438 73.957031 Z M 358.398438 73.957031 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,53.333333%,34.901961%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 358.398438 73.957031 L 358.398438 135.914062 C 358.398438 144.457031 351.472656 151.375 342.941406 151.375 L 275.960938 151.375 L 275.960938 58.496094 L 342.941406 58.496094 C 351.472656 58.496094 358.398438 65.421875 358.398438 73.957031 Z M 358.398438 73.957031 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,29.803922%,1.568627%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 510.804688 139.160156 L 494.375 215.835938 L 487.75 246.753906 L 469.929688 329.914062 C 468.40625 337.046875 462.109375 342.136719 454.820312 342.136719 L 185.0625 342.136719 C 177.878906 342.136719 171.65625 337.191406 170.015625 330.214844 L 152.136719 246.753906 L 152.125 246.753906 L 146.332031 219.691406 L 145.507812 215.835938 L 129.082031 139.160156 C 128.101562 134.597656 129.234375 129.835938 132.171875 126.195312 C 135.109375 122.570312 139.519531 120.457031 144.191406 120.457031 L 495.683594 120.457031 C 500.351562 120.457031 504.773438 122.570312 507.710938 126.195312 C 510.648438 129.835938 511.78125 134.597656 510.804688 139.160156 Z M 510.804688 139.160156 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(74.509804%,92.156863%,98.039216%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 510.804688 139.160156 L 494.375 215.835938 L 487.75 246.753906 L 469.929688 329.914062 C 468.40625 337.046875 462.109375 342.136719 454.820312 342.136719 L 319.9375 342.136719 L 319.9375 120.457031 L 495.683594 120.457031 C 500.351562 120.457031 504.773438 122.570312 507.710938 126.195312 C 510.648438 129.835938 511.78125 134.597656 510.804688 139.160156 Z M 510.804688 139.160156 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(61.960784%,88.627451%,97.254902%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 273.378906 246.753906 L 271.433594 215.835938 L 265.433594 120.457031 L 234.453125 120.457031 L 240.453125 215.835938 L 242.390625 246.753906 L 248.386719 342.136719 L 279.378906 342.136719 Z M 273.378906 246.753906 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862745%,80.784314%,95.686275%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 374.460938 120.457031 L 368.460938 215.835938 L 366.515625 246.753906 L 360.515625 342.136719 L 391.507812 342.136719 L 397.496094 246.753906 L 399.441406 215.835938 L 405.429688 120.457031 Z M 374.460938 120.457031 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,75.294118%,94.117647%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 494.375 215.835938 L 487.75 246.753906 L 152.125 246.753906 L 146.332031 219.691406 L 145.507812 215.835938 Z M 494.375 215.835938 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,75.294118%,94.117647%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 494.375 215.835938 L 487.75 246.753906 L 319.9375 246.753906 L 319.9375 215.835938 Z M 494.375 215.835938 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.882353%,66.27451%,86.666667%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 411.96875 454.128906 L 209.058594 454.128906 C 201.769531 454.128906 195.46875 449.035156 193.941406 441.90625 L 120.71875 100.164062 C 116.964844 82.644531 101.238281 69.929688 83.324219 69.929688 L 35.535156 69.929688 C 26.996094 69.929688 20.074219 63.007812 20.074219 54.472656 C 20.074219 45.933594 26.996094 39.011719 35.535156 39.011719 L 83.324219 39.011719 C 115.722656 39.011719 144.164062 62.007812 150.949219 93.6875 L 221.554688 423.210938 L 411.96875 423.210938 C 420.507812 423.210938 427.425781 430.132812 427.425781 438.671875 C 427.425781 447.207031 420.507812 454.128906 411.96875 454.128906 Z M 411.96875 454.128906 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,75.294118%,94.117647%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 223.75 365.339844 C 183.316406 365.339844 150.421875 398.234375 150.421875 438.667969 C 150.421875 479.105469 183.316406 512 223.75 512 C 264.1875 512 297.082031 479.105469 297.082031 438.667969 C 297.082031 398.234375 264.1875 365.339844 223.75 365.339844 Z M 223.75 365.339844 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.098039%,56.862745%,74.117647%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 297.078125 438.671875 C 297.078125 479.101562 264.183594 512 223.75 512 C 223.546875 512 223.339844 512 223.144531 511.988281 L 223.144531 365.347656 C 223.339844 365.335938 223.546875 365.335938 223.75 365.335938 C 264.183594 365.335938 297.078125 398.234375 297.078125 438.671875 Z M 297.078125 438.671875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,47.45098%,61.568627%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 411.96875 365.339844 C 371.535156 365.339844 338.636719 398.234375 338.636719 438.667969 C 338.636719 479.105469 371.53125 512 411.96875 512 C 452.402344 512 485.300781 479.105469 485.300781 438.667969 C 485.300781 398.234375 452.402344 365.339844 411.96875 365.339844 Z M 411.96875 365.339844 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.098039%,56.862745%,74.117647%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 485.296875 438.671875 C 485.296875 479.101562 452.398438 512 411.96875 512 C 411.761719 512 411.558594 512 411.363281 511.988281 L 411.363281 365.347656 C 411.558594 365.335938 411.761719 365.335938 411.96875 365.335938 C 452.398438 365.335938 485.296875 398.234375 485.296875 438.671875 Z M 485.296875 438.671875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,47.45098%,61.568627%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 454.378906 438.671875 C 454.378906 462.058594 435.355469 481.082031 411.96875 481.082031 C 388.585938 481.082031 369.550781 462.058594 369.550781 438.671875 C 369.550781 415.277344 388.585938 396.253906 411.96875 396.253906 C 435.355469 396.253906 454.378906 415.277344 454.378906 438.671875 Z M 454.378906 438.671875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(74.509804%,92.156863%,98.039216%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 454.378906 438.671875 C 454.378906 462.058594 435.355469 481.082031 411.96875 481.082031 C 411.761719 481.082031 411.566406 481.082031 411.363281 481.070312 L 411.363281 396.265625 C 411.566406 396.253906 411.761719 396.253906 411.96875 396.253906 C 435.355469 396.253906 454.378906 415.277344 454.378906 438.671875 Z M 454.378906 438.671875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(61.960784%,88.627451%,97.254902%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 266.160156 438.671875 C 266.160156 462.058594 247.136719 481.082031 223.75 481.082031 C 200.367188 481.082031 181.34375 462.058594 181.34375 438.671875 C 181.34375 415.277344 200.367188 396.253906 223.75 396.253906 C 247.136719 396.253906 266.160156 415.277344 266.160156 438.671875 Z M 266.160156 438.671875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(74.509804%,92.156863%,98.039216%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 266.160156 438.671875 C 266.160156 462.058594 247.136719 481.082031 223.75 481.082031 C 223.546875 481.082031 223.351562 481.082031 223.144531 481.070312 L 223.144531 396.265625 C 223.351562 396.253906 223.546875 396.253906 223.75 396.253906 C 247.136719 396.253906 266.160156 415.277344 266.160156 438.671875 Z M 266.160156 438.671875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(61.960784%,88.627451%,97.254902%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 241.179688 438.667969 C 241.179688 448.628906 233.105469 456.703125 223.144531 456.703125 C 213.183594 456.703125 205.109375 448.628906 205.109375 438.667969 C 205.109375 428.707031 213.183594 420.632812 223.144531 420.632812 C 233.105469 420.632812 241.179688 428.707031 241.179688 438.667969 Z M 241.179688 438.667969 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.882353%,66.27451%,86.666667%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 429.398438 438.667969 C 429.398438 448.628906 421.324219 456.703125 411.363281 456.703125 C 401.402344 456.703125 393.328125 448.628906 393.328125 438.667969 C 393.328125 428.707031 401.402344 420.632812 411.363281 420.632812 C 421.324219 420.632812 429.398438 428.707031 429.398438 438.667969 Z M 429.398438 438.667969 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.882353%,66.27451%,86.666667%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 133.15625 385.652344 L 72.191406 385.652344 C 63.65625 385.652344 56.734375 392.574219 56.734375 401.113281 C 56.734375 409.652344 63.65625 416.570312 72.191406 416.570312 L 133.15625 416.570312 C 141.691406 416.570312 148.613281 409.652344 148.613281 401.113281 C 148.613281 392.574219 141.691406 385.652344 133.15625 385.652344 Z M 133.15625 385.652344 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(74.509804%,92.156863%,98.039216%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.183594 454.5 L 15.957031 454.5 C 7.421875 454.5 0.5 461.421875 0.5 469.957031 C 0.5 478.496094 7.421875 485.417969 15.957031 485.417969 L 113.183594 485.417969 C 121.722656 485.417969 128.644531 478.496094 128.644531 469.957031 C 128.644531 461.421875 121.722656 454.5 113.183594 454.5 Z M 113.183594 454.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(74.509804%,92.156863%,98.039216%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 241.179688 438.671875 C 241.179688 448.628906 233.109375 456.707031 223.144531 456.707031 L 223.144531 420.636719 C 233.109375 420.636719 241.179688 428.707031 241.179688 438.671875 Z M 241.179688 438.671875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,47.45098%,61.568627%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 429.398438 438.671875 C 429.398438 448.628906 421.328125 456.707031 411.363281 456.707031 L 411.363281 420.636719 C 421.328125 420.636719 429.398438 428.707031 429.398438 438.671875 Z M 429.398438 438.671875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,47.45098%,61.568627%)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicCart);
export default __webpack_public_path__ + "static/media/basicCart.96463f98d50293008ea97f8d8c9245df.svg";
export { ForwardRef as ReactComponent };